var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Led',{attrs:{"active":_vm.active,"powered":_vm.powered,"text":"RTE"}})
}
var staticRenderFns = []

export { render, staticRenderFns }